export default __webpack_public_path__ + "alberta-body-size.25719e988a75e5ac1f51.svg";